import { useEffect, useState } from "react";
import { Checkbox, ListItemText, MenuItem } from "@mui/material";

type Props = {
    items: string[];
    selectedItems: string[];
    setSelectedItems: any;
}

export const FilterSelects = ({ items, selectedItems, setSelectedItems}: Props) => {
   
    const addToItems = (value: string) => {
        setSelectedItems([...selectedItems, value]);
    }

    const removeFromItems = (value: string) => {
        setSelectedItems(selectedItems.filter(item => item !== value));
    }

    const onItemSelected = (e: any, name: string) => {
        if (e.target.checked) {
            addToItems(name)
        }
        else {
            removeFromItems(name)
        }
    }

    return (
        <>
            {
                items.length > 0 ?
                    items.map((name: string) => (
                        <MenuItem key={name} value={name} disableRipple sx={{ width: '100%', paddingLeft: 0, paddingBottom: '3px !important' }}>
                            <Checkbox
                                checked={selectedItems.indexOf(name) > -1}
                                onChange={(e) => onItemSelected(e, name)}
                                style={{color: selectedItems.indexOf(name) > -1 ? '#05B2DC' : '#C4C4C4', height: 16}}
                            />
                            <ListItemText style={{paddingLeft: 3}} primary={name} />
                        </MenuItem>
                    )) : <></>
            }
        </>
    )
}